<template src="./Index.html">
</template>


<script>
import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
  },
  created() {
    this.$store.dispatch("lookups/getLookups");

    this.getAll();
  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.instructions.totalItems / this.filters.pageSize
      );
    },
    instructions() {
      return this.$store.state.instructions.instructionsList;
    }, 
 
  },

  data() {
    return {
      permissions: this.$settingPermissions.analysisPermissions,

      view: 0,
      dialog: false,
      dialogType: null,
      dialogMessage: "",

      filters: {
        page: 1,
        pageSize: 10,
     
      },
      headers: [
        { text: 'اسم النصحة', value: 'title' },
        // { text: 'المحتوى ', value: 'tipContent' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("instructions/getAll", this.filters);

    },

    addItem() {
      this.view = 1;
    },
    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
      // Implement view logic
    },
    editItem(item) {
      this.itemId = item.id;
      this.view = 2;
      // Implement edit logic
    }, 
    serviesDetailsView(item) {
      this.itemId = item.id;
      this.view = 4;
      // Implement edit logic
    },
    // // -------------- end empDialog  -----
    showDialog(item, type) {
      switch (type) {
        case "delete":
          this.dialogMessage = "هل انت متأكد من رغبتك حذف النصيحة";
          break;


      }
      this.dialogType = type;
      this.itemId = item.id;
      this.dialog = true;
    },

    confirmDialog() {
      this.$store.dispatch(`instructions/${this.dialogType}`, this.itemId);
      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.itemId = 0;
      this.dialogMessage = "";
      this.dialogType = null;
    },
    print(item) {
      this.itemId = item.id;
      const routeData = this.$router.resolve(
        `/instructions-print/${this.itemId}`
      );
      window.open(routeData.href, "_blank");
    },
  
    back() {
      this.view = 0;
    }
  },
};
</script>

<style scoped></style>